module.exports = __webpack_public_path__ + "img/iripple-logo-primary-dark.14d19cfb.png";